<div class="min-h-screen flex bg-gray-100">
  <!-- Sidebar -->
  <aside class="w-64 bg-white shadow-lg p-5">
    <h2 class="text-2xl font-bold text-blue-600 mb-6">Dashboard</h2>
    <nav class="space-y-3">
      <a *ngFor="let item of menuItems"
         [routerLink]="item.path"
         class="block p-3 rounded-lg hover:bg-blue-50">
        {{ item.label }}
      </a>
    </nav>
  </aside>

  <!-- Main Content -->
  <main class="flex-1 p-8">
    <router-outlet></router-outlet>
  </main>
</div>

